const SkeletonLoader = ({ height = "h-4", width = "w-3/4" }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${height} ${width}`}></div>
);

const DetalleViajeSkeleton = () => (
  <div className="space-y-3 p-3">
    {/* Skeleton para Información del Viaje */}
    <div className="bg-white rounded-lg shadow-sm p-3 space-y-3">
      <SkeletonLoader width="w-1/2" />
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div>
          <SkeletonLoader />
        </div>
        <div>
          <SkeletonLoader />
        </div>
        <div>
          <SkeletonLoader />
        </div>
        <div>
          <SkeletonLoader />
        </div>
      </div>
    </div>
    {/* Skeleton para Tramos */}
    <div className="bg-white rounded-lg shadow-sm p-3 space-y-3">
      <SkeletonLoader width="w-2/3" />
      <SkeletonLoader height="h-10" />
      <SkeletonLoader height="h-10" />
    </div>
    {/* Skeleton para Seguimiento GPS */}
    <div className="bg-white rounded-lg shadow-sm p-3">
      <SkeletonLoader width="w-1/3" />
      <SkeletonLoader />
    </div>
  </div>
);
export default DetalleViajeSkeleton;
